export default "__VITE_ASSET__Dz8_h49W__"